import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { finalize } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { CustomerGroupsService } from '../../../services/customer-groups/customer-groups-service';
import { CustomerGroup } from '../../../models/customer-group';
import { AddGroupForm } from '../../../@shared/forms/customer-groups/add-group-form/add-group-form';

@Component({
  selector: 'app-customer-groups-page',
  imports: [AddGroupForm, DialogModule, RouterLink],
  templateUrl: './customer-groups-page.html',
  styleUrl: './customer-groups-page.scss',
})
export class CustomerGroupsPage implements OnInit {
  private service         = inject(CustomerGroupsService);
  private router          = inject(Router);

  @ViewChild(AddGroupForm) addGroupForm?: AddGroupForm;

  groups  = signal<CustomerGroup[]>([]);
  loading = signal(false);

  addDialogVisible = false;
  editingGroup: CustomerGroup | null = null;

  deletingGroup: CustomerGroup | null = null;
  confirmDeleteVisible = false;
  deleteLoading = signal(false);

  ngOnInit() { this.load(); }

  load() {
    this.loading.set(true);
    this.service.getGroups({ sortBy: 'createdAt', sortDirection: 'DESC' })
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({ next: res => { this.groups.set(res.data?.content ?? []); } });
  }

  openGroup(group: CustomerGroup) { this.router.navigate(['/customer-groups', group.id]); }

  onGroupCardClick(event: MouseEvent, group: CustomerGroup) {
    if (event.ctrlKey || event.metaKey) return;
    event.preventDefault();
    this.openGroup(group);
  }

  openCreate() {
    this.editingGroup = null;
    this.addDialogVisible = true;
  }

  openEdit(group: CustomerGroup, event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.editingGroup = group;
    setTimeout(() => { this.addDialogVisible = true; });
  }

  openDelete(group: CustomerGroup, event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.deletingGroup = group;
    this.confirmDeleteVisible = true;
  }

  confirmDeleteGroup() {
    if (!this.deletingGroup) return;
    this.deleteLoading.set(true);
    this.service.deleteGroup(this.deletingGroup.id)
      .pipe(finalize(() => this.deleteLoading.set(false)))
      .subscribe({ next: () => {
        this.confirmDeleteVisible = false;
        this.deletingGroup = null;
        this.load();
      }});
  }

  onGroupSaved() { this.addDialogVisible = false; this.load(); }
}
